module.exports = __webpack_public_path__ + "img/x1-two.32bbcafd.png";